import { SiteContent } from './types'



export const defaultContent: SiteContent = {
  hero: {
    title: "ДОВІРТЕ НАМ СВОЮ НЕРУХОМІСТЬ",
    description:
      "OBELISK - компанія, що спеціалізується на ремонтах під ключ. Ми беремо на себе повний цикл робіт — від проєктування до здачі об'єкта в готовому вигляді. Нам довіряють у Львові, по всій Україні, а також за кордоном. Сьогодні ми надаємо послуги ремонту під ключ і у Франції — зокрема в Парижі.",
    bullets: [
      "терміни виконання",
      "робота з дизайнерами та інженерами",
      "врахування реальних технічних можливостей",
      "перевірені фахівці",
      "гарантія на виконані роботи",
    ],
  },
  stats: [
    { id: 1, value: 150, suffix: "+", description: "реалізованих проєктів" },
    { id: 2, value: 7, suffix: "", description: "років на ринку" },
    { id: 3, value: 200, suffix: "+", description: "задоволених клієнтів" },
    { id: 4, value: 5, suffix: " р.", description: "років гарантії" },
  ],
  advantages: {
    sectionTitle: "Обирайте компанію OBELISK, бо ми:",
    items: [
      {
        id: 1,
        title: "Реалізуємо складні нетипові проєкти",
        description:
          "Беремося за найскладніші та нестандартні завдання, які інші не наважуються виконувати",
      },
      {
        id: 2,
        title: "Чітко і поетапно плануємо роботи",
        description:
          "Детальне планування кожного етапу з прозорим графіком виконання робіт",
      },
      {
        id: 3,
        title: "Створюємо індивідуальний та комплексний підхід без хаосу",
        description:
          "Персональний підхід до кожного клієнта з урахуванням всіх побажань та особливостей",
      },
      {
        id: 4,
        title: "Дотримуємось чітких термінів",
        description:
          "Завершуємо роботи точно в обумовлені терміни без затримок та переносів",
      },
      {
        id: 5,
        title: "Контролюємо та гарантуємо якість",
        description:
          "Багаторівневий контроль якості на кожному етапі з гарантією до 5 років",
      },
      {
        id: 6,
        title: "Поєднуємо функціональність та естетику",
        description:
          "Створюємо простори, які є не тільки красивими, але й максимально функціональними",
      },
      {
        id: 7,
        title: "Економимо ваш час та бюджет",
        description:
          "Оптимізуємо витрати без втрати якості, працюємо ефективно та економно",
      },
      {
        id: 8,
        title: "Втілюємо в життя ваші мрії про затишок і комфорт",
        description:
          "Створюємо простір, в якому ви будете почуватися щасливими та комфортно",
      },
    ],
  },
  services: {
    sectionTitle: "Мрійте, бо все інше входить в наші послуги:",
    items: [
      {
        id: 1,
        title: "Виїзд на об'єкт та консультація",
        description:
          "Оцінюємо стан приміщення, прораховуємо вартість та обсяг робіт, виставляємо терміни здачі об'єкта",
      },
      {
        id: 2,
        title: "Закупівля та логістика матеріалів",
        description:
          "Обираємо найбільш якісні матеріали відповідно до потреб замовника і самі доставляємо їх на об'єкт",
      },
      {
        id: 3,
        title: "Демонтажні роботи",
        description:
          "Знесення стін та перегородок, зняття старого покриття (плитка, підлога, шпалери, фарба, штукатурка), вивіз будівельного сміття",
      },
      {
        id: 4,
        title: "Чорнові будівельні роботи",
        description:
          "Вирівнюємо стіни та стелі, робимо стяжку підлоги, монтуємо гіпсокартон та ніші",
      },
      {
        id: 5,
        title: "Проведення комунікацій",
        description:
          "Виконуємо сантехнічні роботи, займаємось електромонтажем, встановлюємо опалення, вентиляцію, кондиціонування",
      },
      {
        id: 6,
        title: "Чистові оздоблювальні роботи",
        description:
          "Наносимо штукатурку, шпаклюємо, фарбуємо або клеїмо шпалери чи декоративні покриття, укладаємо плитку, ламінат чи паркет",
      },
      {
        id: 7,
        title: "Монтажні роботи",
        description:
          "Установлюємо двері, монтуємо сантехніку, освітлення, встановлюємо меблі",
      },
      {
        id: 8,
        title: "Прибирання та здача об'єкта",
        description: "Запрошуємо клінінг, віддаємо вам ключ і радіємо разом з вами",
      },
    ],
  },
  faq: {
    sectionTitle: "Найпопулярніші запитання про ремонт квартири",
    items: [
      {
        id: 1,
        question: "Яка гарантія надається на ремонт?",
        answer:
          "При умові, що ми закуповуємо матеріал та працюємо на усіх етапах ремонту від початку до кінця, гарантія на сантехнічні та електромонтажні роботи становить 5 років.",
      },
      {
        id: 2,
        question: "Від чого залежить вартість ремонту?",
        answer:
          "Вартість ремонту залежить від наповнення, площі і від вартості чистових матеріалів, які клієнт обирає та оплачує окремо.",
      },
      {
        id: 3,
        question: "Чи входить вартість матеріалів у вартість ремонту?",
        answer: "Так, матеріали як чорнові, так і чистові входять у вартість ремонту.",
      },
      {
        id: 4,
        question: "Хто купує матеріали?",
        answer:
          "Зазвичай, при виконанні ремонту \"під ключ\", усі матеріали закуповуємо ми, проте були випадки, коли закупівлею займалися самі замовники. Ми ж радимо довірити закупівлю матеріалів нам, адже ми роками перевіряємо бренди, виробництва та постачальників, щоб бути впевненими в якості та гарантувати довгий термін експлуатації.",
      },
      {
        id: 5,
        question: "Скільки часу триває ремонт?",
        answer: "Від 4 місяців до 12, залежно від площі та складності робіт.",
      },
      {
        id: 6,
        question: "Що робити, якщо ремонт зіпсується з провини сусідів?",
        answer:
          "В такому випадку, ми рекомендуємо робити офіційні документи, а саме додатково замовити в нас акти КБ. Для чого потрібен акт? Для підтвердження виконання робіт та послуг: акт є офіційним документом, який свідчить про те, що роботи виконані та послуги надані у повному обсязі та відповідно до умов договору.",
      },
      {
        id: 7,
        question: "Що робити, якщо щось не подобається після зроблених робіт?",
        answer:
          "Якщо є помітні дефекти, потрібно одразу повідомити нас і ми швидко все виправимо. Усі решта побажання та зауваження варто проговорювати перед початком кожного етапу ремонту. Таким чином можна уникнути неприємних ситуацій.",
      },
    ],
  },
  pricing: [
    {
      id: "pricing-basic",
      price: "700-850$",
      title: "Базовий ремонт",
      features: [
        "Cантехнічні, електромонтажні роботи",
        "Cтіни — гіпсова штукатурка, подальше її оздоблення під фарбування миючою фарбою",
        "Вікна — утеплення віконних відкосів",
        "Плитка — середнього формату, плиточні роботи",
        "Підлога — електричний підігрів підлоги у ванній кімнаті та коридорі, зносостійкий ламінат, пластиковий плінтус",
        "Стеля — натяжна, накладні світильники",
        "Двері — пустотілий ДСП/ДВП, якісна фурнітура",
        "Меблі — МДФ",
      ],
    },
    {
      id: "pricing-standard",
      price: "950-1100$",
      title: "Стандартний ремонт",
      features: [
        "Сантехнічні, електромонтажні роботи, дистанційне керування опаленням",
        "Стіни — гіпсова штукатурка, подальше її оздоблення під фарбування, додатковий захист від великих тріщин",
        "Вікна — утеплення віконних відкосів",
        "Плитка — середній та дрібний формат, плиточні роботи",
        "Підлога — підігрів підлоги у ванній, коридорі, кухні (електричний, водяний або комбінований), часткове або повне утеплення підлоги, вінілове покриття, ламінат, плінтуса МДФ",
        "Стеля — гіпсокартон, комбінація врізних та накладних світильників, трекові системи",
        "Двері — каркас з сосни або МДФ, якісна фурнітура",
        "Меблі — МДФ шпонований",
      ],
    },
    {
      id: "pricing-premium",
      price: "1500-1700$",
      title: "Преміум ремонт",
      features: [
        "Електромонтажні, сантехнічні роботи, дистанційне керування опаленням в кожній окремій кімнаті",
        "Стіни — гіпсова штукатурка, з оздобленням під фарбування зносостійкою фарбою з антибактеріальним ефектом, повний захист від тріщин будь-якого походження",
        "Двері та вікна — масив дерева: дуб, ясен, сосна, встановлюємо двері прихованого монтажу, утеплення віконних відкосів",
        "Плитка — дрібний та великий формат, плиточні роботи",
        "Підлога — водяний підігрів підлоги, її утеплення на всю площу приміщення, дерев'яна підлога, дерев'яний або металевий плінтус",
        "Стеля — гіпсокартон, шумоізоляція, тіньовий профіль з LED підсвіткою, гіпсові врізні світильники або запропонований вами інший варіант",
        "Меблі — дерево",
        "Реалізація індивідуальних дизайнерських рішень будь-якої складності",
      ],
    },
  ],
  contacts: {
    phone: "+38 063 664 41 32",
    phoneHref: "tel:+380636644132",
    email: "obelisk79011@gmail.com",
    emailHref: "mailto:obelisk79011@gmail.com",
    address: "Львів, вул. І.Франка 45",
    mapHref: "https://maps.app.goo.gl/mH3oEa8JCmG7QyQH9",
    workHours: "Пн–Сб: 10:00 – 17:00",
  },
  reviews: [
    {
      id: 1,
      author: "Artem Flood",
      rating: 5,
      text: "Дуже довго шукали бригаду, якій можна довіряти ремонт квартири, і не пожалкували, що зупинились на Obelisk! Все було прозоро від першого дзвінка до фінального прибирання — кошторис без сюрпризів, постійний зв'язок, відповіді на всі питання. Майстри реально розуміються на своїй справі: підказали по матеріалах, врахували наші побажання по дизайну. Квартира вийшла саме такою, як ми хотіли. Рекомендую всім, хто цінує якість і чесність!",
      date: "Червень 2025",
    },
    {
      id: 2,
      author: "Юра Спондич",
      rating: 5,
      text: "",
      date: "Червень 2025",
    },
  ],
}
